import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-regiao-industrial',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-regiao-industrial.component.html',
  styleUrls: ['./filtro-regiao-industrial.component.scss'],
})
export class FiltroRegiaoIndustrialComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  filtroRegiao: any[] = [];
  regiaoSelecionada: number = 0;
  states: any[] = [];
  cities: { [key: number]: any[] } = {};
  defaultRegion: number = null;
  defaultState: number = null;

  @Input() buscaSalvaRegiao: any = null;
  @Input() idModuloSelecionado: number;
  @Input() bloquearAcao: boolean = false;
  @Input() regiaoSelecionadaBusca: number | null = null;
  @Input() statesSelecionadosBusca: number[] = [];
  @Input() citiesSelecionadasBusca: number[] = [];
  @Output() filtrosChange = new EventEmitter<any>();
  @Input() disabled: boolean = false;

  private subscriptions: Subscription = new Subscription();

  selectedStates: number[] = [];
  selectedCities: number[] = [];
  addressStateID: string = '0';
  addressCityID: string = '0';
  addressRegionID: number = 0;
  exibirTodasRegioes: boolean = false;

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private readonly _errorHandleService: ErrorHandleService,
  ) {}

  async ngOnInit() {
    (window as any).filtroRegiaoIndustrialComponentInstance = this;
    await this.filtroRegiaoOutrosModulos();

    if (this.buscaSalvaRegiao) {
      setTimeout(() => {
        this.aplicarBuscaSalvaRegiaoIndustrial(this.buscaSalvaRegiao);
      }, 0);
    } else if (
      this.regiaoSelecionadaBusca ||
      (this.statesSelecionadosBusca &&
        this.statesSelecionadosBusca.length > 0) ||
      (this.citiesSelecionadasBusca && this.citiesSelecionadasBusca.length > 0)
    ) {
      this.sincronizarBuscaSalva();
    }
  }

  aplicarBuscaSalvaRegiaoIndustrial(busca: any) {
    if (!busca) {
      return;
    }
    const regionId =
      busca.AddressRegionID != null
        ? Number(busca.AddressRegionID)
        : busca.addressRegionID != null
          ? Number(busca.addressRegionID)
          : null;

    if (regionId != null) {
      this.regiaoSelecionada = regionId;
      this.addressRegionID = regionId;
      const selectedRegion = this.filtroRegiao.find(
        (region) => Number(region.regionID) === regionId,
      );

      if (selectedRegion) {
        this.states = selectedRegion.states || [];
        this.cities = {};
        this.states.forEach((state) => {
          this.cities[state.stateID] = state.cities || [];
        });
      }
    }

    let stateIds: number[] = [];
    let cityIds: number[] = [];

    const stateIdRaw =
      busca.addressStateID !== undefined && busca.addressStateID !== null
        ? busca.addressStateID
        : busca.AddressStateID !== undefined && busca.AddressStateID !== null
          ? busca.AddressStateID
          : undefined;

    if (stateIdRaw !== undefined && stateIdRaw !== null) {
      if (Array.isArray(stateIdRaw)) {
        stateIds = stateIdRaw.map(Number);
      } else if (typeof stateIdRaw === 'number') {
        stateIds = [stateIdRaw];
      } else {
        stateIds = [Number(stateIdRaw)];
      }

      this.addressStateID = stateIds.length > 0 ? String(stateIds[0]) : '0';
    }

    const cityIdRaw =
      busca.addressCityID !== undefined && busca.addressCityID !== null
        ? busca.addressCityID
        : busca.AddressCityID !== undefined && busca.AddressCityID !== null
          ? busca.AddressCityID
          : undefined;
    if (cityIdRaw !== undefined && cityIdRaw !== null) {
      if (Array.isArray(cityIdRaw)) {
        cityIds = cityIdRaw.map(Number);
      } else if (typeof cityIdRaw === 'number') {
        cityIds = [cityIdRaw];
      } else {
        cityIds = String(cityIdRaw)
          .split(',')
          .map(Number)
          .filter((v) => !isNaN(v));
      }

      Object.keys(this.cities).forEach((stateIdStr) => {
        const stateId = Number(stateIdStr);
        const cidadesArr = this.cities[stateId] || [];
        const cidadeSelecionada = cidadesArr.some((city) =>
          cityIds.includes(city.cityID),
        );
        if (cidadeSelecionada && !stateIds.includes(stateId)) {
          stateIds.push(stateId);
        }
      });
    }

    this.selectedStates = stateIds;
    this.addressStateID = stateIds.length > 0 ? stateIds.join(',') : '0';

    this.states.forEach((state) => {
      state.checked = this.selectedStates.includes(state.stateID);

      if (this.selectedStates.includes(state.stateID)) {
        state.isDropdownOpen = true;
      }
    });

    this.selectedCities = cityIds;
    this.addressCityID = cityIds.length > 0 ? cityIds.join(',') : '0';

    Object.keys(this.cities).forEach((stateIdStr) => {
      const stateId = Number(stateIdStr);
      const cidadesArr = this.cities[stateId] || [];
      const algumaCidadeSelecionada = cidadesArr.some((city) =>
        cityIds.includes(city.cityID),
      );
      cidadesArr.forEach((city) => {
        city.checked = cityIds.includes(city.cityID);
      });

      const state = this.states.find((s) => s.stateID === stateId);
      if (state && algumaCidadeSelecionada) {
        state.isDropdownOpen = true;
      }
    });

    if (busca.addressCityID) {
      if (Array.isArray(busca.addressCityID)) {
        cityIds = busca.addressCityID.map(Number);
      } else {
        cityIds = String(busca.addressCityID)
          .split(',')
          .map(Number)
          .filter((v) => !isNaN(v));
      }
      this.selectedCities = cityIds;
      this.addressCityID = cityIds.join(',');

      Object.keys(this.cities).forEach((stateIdStr) => {
        const stateId = Number(stateIdStr);
        const cidadesArr = this.cities[stateId] || [];
        const algumaCidadeSelecionada = cidadesArr.some((city) =>
          cityIds.includes(city.cityID),
        );
        cidadesArr.forEach((city) => {
          city.checked = cityIds.includes(city.cityID);
        });

        const state = this.states.find((s) => s.stateID === stateId);
        if (state && algumaCidadeSelecionada) {
          state.isDropdownOpen = true;
        }
      });
    }

    this.emitFiltrosAtualizados();
  }

  ngOnChanges(changes: any) {
    if (
      changes.buscaSalvaRegiao &&
      changes.buscaSalvaRegiao.currentValue &&
      this.filtroRegiao.length > 0
    ) {
      this.aplicarBuscaSalvaRegiaoIndustrial(
        changes.buscaSalvaRegiao.currentValue,
      );
      return;
    }
    if (
      (changes.regiaoSelecionadaBusca ||
        changes.statesSelecionadosBusca ||
        changes.citiesSelecionadasBusca) &&
      this.filtroRegiao.length > 0
    ) {
      this.sincronizarBuscaSalva();
    }
  }

  async filtroRegiaoOutrosModulos(): Promise<void> {
    return new Promise((resolve) => {
      this.subscriptions.add(
        this._filtroBuscaService.filtroRegiaoIndustrial().subscribe({
          next: (res) => {
            if (res.success) {
              const data = Array.isArray(res.data?.regions)
                ? res.data.regions
                : [];

              this.filtroRegiao = data.sort((a, b) =>
                a.regionDescription.localeCompare(b.regionDescription),
              );

              this.defaultRegion = res.data.defaultRegion;

              if (!this.regiaoSelecionadaBusca) {
                this.regiaoSelecionada = this.defaultRegion;
                const regiaoSelecionadaObj = this.filtroRegiao.find(
                  (r) => r.regionID === this.defaultRegion,
                );
                if (this.defaultRegion === 0) {
                  this.onSelectChange({
                    target: { value: this.regiaoSelecionada },
                  } as any as Event);
                } else if (regiaoSelecionadaObj?.states?.length > 0) {
                  this.states = regiaoSelecionadaObj.states.map((state) => ({
                    ...state,
                    checked: true,
                    isDropdownOpen: false,
                    cities: (state.cities || []).map((city: any) => ({
                      ...city,
                      checked: false,
                    })),
                  }));
                  this.selectedStates = this.states.map(
                    (state) => state.stateID,
                  );
                  this.addressStateID = this.selectedStates.join(',');
                  this.addressRegionID = Number(this.defaultRegion);
                  this.cities = {};
                  this.states.forEach((state) => {
                    this.cities[state.stateID] = state.cities;
                  });
                }
              }

              this.emitFiltrosAtualizados();
              resolve();
            } else {
              this._errorHandleService.throwConsoleError(res.message);
              resolve();
            }
          },
          error: () => resolve(),
        }),
      );
    });
  }

  sincronizarBuscaSalva() {
    if (this.regiaoSelecionadaBusca != null) {
      this.regiaoSelecionada = this.regiaoSelecionadaBusca;
      this.addressRegionID = this.regiaoSelecionadaBusca;

      const selectedRegion = this.filtroRegiao.find(
        (region) => region.regionID === this.regiaoSelecionada,
      );

      if (selectedRegion) {
        this.states = selectedRegion.states || [];
        this.cities = {};
        this.states.forEach((state) => {
          this.cities[state.stateID] = state.cities || [];
        });
      }
    }

    if (
      Array.isArray(this.statesSelecionadosBusca) &&
      this.statesSelecionadosBusca.length > 0
    ) {
      this.selectedStates = [...this.statesSelecionadosBusca];
      this.addressStateID = this.selectedStates.join(',');

      this.states.forEach((state) => {
        state.checked = this.selectedStates.includes(state.stateID);
      });
    }

    if (
      Array.isArray(this.citiesSelecionadasBusca) &&
      this.citiesSelecionadasBusca.length > 0
    ) {
      this.selectedCities = [...this.citiesSelecionadasBusca];
      this.addressCityID = this.selectedCities.join(',');

      Object.keys(this.cities).forEach((stateIdStr) => {
        const stateId = Number(stateIdStr);
        const cidades = this.cities[stateId] || [];

        const algumaCidadeSelecionada = cidades.some((city) =>
          this.citiesSelecionadasBusca.includes(city.cityID),
        );

        cidades.forEach((city) => {
          city.checked = this.selectedCities.includes(city.cityID);
        });

        const state = this.states.find((s) => s.stateID === stateId);
        if (state) state.isDropdownOpen = algumaCidadeSelecionada;
      });
    }

    this.emitFiltrosAtualizados();
  }

  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = Number(selectElement.value);
    this.regiaoSelecionada = selectedValue;
    this.addressRegionID = selectedValue;

    this.selectedStates = [];
    this.selectedCities = [];
    this.addressStateID = '0';
    this.addressCityID = '0';
    this.states = [];
    this.cities = {};

    const selectedRegion = this.filtroRegiao.find(
      (region) => Number(region.regionID) === selectedValue,
    );

    if (selectedRegion) {
      this.states = (selectedRegion.states || []).map((state: any) => ({
        ...state,
        stateID: Number(state.stateID),
        checked: false,
        isDropdownOpen: false,
        cities: (state.cities || []).map((city: any) => ({
          ...city,
          cityID: Number(city.cityID),
          checked: false,
        })),
      }));

      this.cities = {};
      this.states.forEach((state) => {
        this.cities[state.stateID] = state.cities;
      });
    }

    this.updateFilterRegiao(this.regiaoSelecionada);
    this.emitFiltrosAtualizados();
  }

  /**
   * Volta a região para o padrão do usuário e limpa as cidades. Usado pelo
   * "Limpar filtros": quem tem restrição de região não pode ficar sem estado.
   */
  restaurarPadrao(): void {
    const regiaoPadrao = this.filtroRegiao.find(
      (r) => Number(r.regionID) === Number(this.defaultRegion),
    );

    if (!this.defaultRegion || !regiaoPadrao?.states?.length) {
      // Sem restrição: comportamento normal de "todas as regiões"
      this.onSelectChange({
        target: { value: this.defaultRegion ?? 0 },
      } as any as Event);
      return;
    }

    this.regiaoSelecionada = Number(this.defaultRegion);
    this.addressRegionID = Number(this.defaultRegion);

    this.states = regiaoPadrao.states.map((state: any) => ({
      ...state,
      stateID: Number(state.stateID),
      checked: true,
      isDropdownOpen: false,
      cities: (state.cities || []).map((city: any) => ({
        ...city,
        cityID: Number(city.cityID),
        checked: false,
      })),
    }));

    this.selectedStates = this.states.map((state) => state.stateID);
    this.addressStateID = this.selectedStates.join(',') || '0';

    this.selectedCities = [];
    this.addressCityID = '0';

    this.cities = {};
    this.states.forEach((state) => {
      this.cities[state.stateID] = state.cities;
    });

    this.updateFilterRegiao(this.regiaoSelecionada);
    this.emitFiltrosAtualizados();
  }

  onStatesCheckboxChange(state: any, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const stateID = state.stateID;
    if (checkbox.checked) {
      if (!this.selectedStates.includes(stateID)) {
        this.selectedStates.push(stateID);
      }
    } else {
      this.selectedStates = this.selectedStates.filter((id) => id !== stateID);
    }
    this.addressStateID =
      this.selectedStates.length > 0 ? this.selectedStates.join(',') : '0';
    this.updateFilterRegiao(this.regiaoSelecionada);
    this.emitFiltrosAtualizados();
  }

  onCitiesCheckboxChange(city: any, citiesArr: any[], event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const cityID = city.cityID;
    if (checkbox.checked) {
      if (!this.selectedCities.includes(cityID)) {
        this.selectedCities.push(cityID);
      }
    } else {
      this.selectedCities = this.selectedCities.filter((id) => id !== cityID);
    }
    this.addressCityID =
      this.selectedCities.length > 0 ? this.selectedCities.join(',') : '0';
    this.updateFilterRegiao(this.regiaoSelecionada);
    this.emitFiltrosAtualizados();
  }

  toggleDropdownIcon(state: any): void {
    state.isDropdownOpen = !state.isDropdownOpen;
  }

  updateFilterRegiao(regiaoSelecionada: number): void {
    let filtros = [];
    try {
      const raw = localStorage.getItem('filtros_busca_outros_modulos');
      const parsed = raw ? JSON.parse(raw) : [];
      filtros = Array.isArray(parsed) ? parsed : [];
    } catch {
      filtros = [];
    }
    filtros = filtros.filter((f: any) => f.filtroGrupo !== 'Região');
    filtros.push({
      filtroGrupo: 'Região',
      filtroID: regiaoSelecionada,
      checked: true,
      description: 'Região',
    });
    localStorage.setItem(
      'filtros_busca_outros_modulos',
      JSON.stringify(filtros),
    );
  }
  emitFiltrosAtualizados(): void {
    let regionIDToSend = this.addressRegionID;
    let stateIDToSend = this.addressStateID;

    // Usa defaultRegion apenas como fallback quando nenhuma região foi selecionada
    if (
      (!regionIDToSend || regionIDToSend === 0) &&
      this.defaultRegion &&
      this.defaultRegion !== 0
    ) {
      regionIDToSend = this.defaultRegion;
      if (!this.selectedStates || this.selectedStates.length === 0) {
        const regiao = this.filtroRegiao.find(
          (r) => r.regionID === this.defaultRegion,
        );
        if (regiao && regiao.states && regiao.states.length > 0) {
          stateIDToSend = regiao.states.map((s) => s.stateID).join(',');
        }
      }
    }

    const filtrosEmitidos = {
      regiao: String(regionIDToSend ?? '0'),
      addressRegionID: String(regionIDToSend ?? '0'),
      addressStateID: String(stateIDToSend ?? '0'),
      addressCityID: String(this.addressCityID ?? '0'),
    };
    this.filtrosChange.emit(filtrosEmitidos);
  }
}
